import { componentSelector } from 'wordpress/selectors'
import Search from './Search'
import Gallery from './Gallery'

import { setParkingMode } from 'booking/actions'
import { parkingModeSelector } from 'booking/selectors'
import '../styles/FindAndBook.scss'

const FindAndBook = ({ search: { gallery, title }, setParkingMode, parkingMode }) => {
    const [isFocused, setIsFocused] = React.useState(false)

    return (
        <div className={`find-and-book d-flex ${isFocused ? 'focused' : ''}`}>
            <Gallery gallery={gallery} />
            <div className="content">
                <div className="row no-gutters justify-content-center">
                    <div className="col-sm-auto">{title && <h1 className="text-white">{title}</h1>}</div>
                    <div className="w-100"></div>
                    <div className="col-sm-6 col-lg-5 col-xl-4 mt-5">
                        <div className="search-selection-container">
                            <Search setParkingMode={setParkingMode} parkingMode={parkingMode} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    search: componentSelector('search'),
    parkingMode: parkingModeSelector,
})

export default connect(mapStateToProps, { setParkingMode })(FindAndBook)
